import {styled} from '@innowise-group/ui-kit';

export const NoMatches = styled.div`
  display: flex;
  justify-content: center;
`;
